var _rect, _path, _path2, _path3, _path4, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMortgageRefinance(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 8,
    fill: "url(#mortgageRefinanceSvg)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m9.17 22.83 12-12a4 4 0 0 1 5.66 0l12 12A4 4 0 0 1 40 25.66V36a4 4 0 0 1-4 4H12a4 4 0 0 1-4-4V25.66a4 4 0 0 1 1.17-2.83Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.17 35v-4.67h4.66",
    stroke: "#E15F49",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.83 21v4.67h-4.66",
    stroke: "#E4644D",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.91 26c.42 0 .8-.25 1.02-.6a4.83 4.83 0 0 1 8.47.6h2.14a6.84 6.84 0 0 0-12.5-1.33c-.36.63.15 1.33.87 1.33Zm.69 4h-2.14a6.84 6.84 0 0 0 12.51 1.33c.35-.63-.16-1.33-.88-1.33-.42 0-.8.25-1.02.6a4.83 4.83 0 0 1-8.47-.6Z",
    fill: "#E4624C"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "mortgageRefinanceSvg",
    x1: 0,
    y1: 0.26,
    x2: 49.22,
    y2: 46.71,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9B88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EA3829"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMortgageRefinance);
export default __webpack_public_path__ + "static/media/MortgageRefinance.6dabcb22836811a7c3433801e9c34c09.svg";
export { ForwardRef as ReactComponent };